import { createRef } from 'react';

import Button from '~components/generic/elements/Button';

interface ModuleSearchProps {
  onSearchInput: (value: string) => void;
}

export function ModuleSearch({ onSearchInput }: ModuleSearchProps) {
  const refInput = createRef<HTMLInputElement>();

  return (
    <div className="u-margin-bottom-xl pr-3">
      <form id="search-form">
        <div className="form--inline form-inline clearfix">
          <div className="c-input-group">
            <Button
              type="submit"
              label="Search"
              hideLabel={true}
              iconName="search"
              iconSize="lg"
              className="bg-white border-0 u-padding-vertical-none"
            />
            <input
              onChange={e => onSearchInput(e.target.value)}
              placeholder="Filter modules"
              type="text"
              ref={refInput}
              className="form-text c-input u-full-width"
              aria-label="Search term"
            />
          </div>
        </div>
      </form>
    </div>
  );
}
